// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".case-viewers select[multiple][data-v-3579572b]{min-height:200px;width:100%}", "",{"version":3,"sources":["webpack://./resources/js/Components/Admin/AdminBoxViewers.vue"],"names":[],"mappings":"AAGC,gDAEC,gBAAA,CADA,UADF","sourcesContent":["\n\n.case-viewers\n\tselect[multiple]\n\t\twidth: 100%\n\t\tmin-height: 200px\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
